// States where Ballotpedia doesn't provide local election coverage.
// Update this set as Ballotpedia expands its coverage.
// These are the current states that do not have coverage
export const BALLOTPEDIA_GAP_STATES = new Set([
  'AL',
  'AK',
  'CO',
  'CT',
  'KS',
  'LA',
  'MD',
  'MA',
  'MS',
  'MO',
  'NH',
  'NJ',
  'NY',
  'ND',
  'TN',
  'UT',
  'VT',
  'WV',
]);
